import { updateHomePageCategory } from '../../..../../../actions/siteadmin/updateHomePageCategory'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

async function submit(values, dispatch) {
    let havingDataWithoutImage = !values?.logo || !values?.banner;

    if (havingDataWithoutImage) {
        showToaster({ messageId: 'pleaseUpload', toasterType: 'error' });
        return;
    }

    await dispatch(updateHomePageCategory({ categoryList: values }))
}

export default submit;